import { render, staticRenderFns } from "./LocationQuestion.vue?vue&type=template&id=e6f3d0a6&scoped=true"
import script from "./LocationQuestion.vue?vue&type=script&lang=js"
export * from "./LocationQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f3d0a6",
  null
  
)

export default component.exports